var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bundleDiscount)?_c('section',{staticClass:"bundle-discount-section"},[_c('bundle-discount-pill-with-title',{attrs:{"label-color":_vm.bundleDiscount.label_color,"title":_vm.bundleDiscount.title}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }